


























































import { Component } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay, CardForm } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import CurrencyApi from '@/services/rest/bemob/currency';
import currencyList from '@/components/helpers/currency-list';

interface Rates {
  fromCurrency: string;
  rate: number;
  toCurrency: string;
}

@Component({
  components: {
    FormOverlay,
    DialogForm,
    CardForm,
    HeaderButtons
  }
})
export default class CreateWorkspaceDialog extends Form {
  currencyApi: CurrencyApi = new CurrencyApi();
  show: boolean = false;
  loading: boolean = false;
  rates: Rates[] = [];

  get filteredRates() {
    const { preferredCurrency } = this.$store.state.user

    return this.rates
      .filter(({ toCurrency }: Rates): boolean => toCurrency !== this.currencyId)
      .sort((a: Rates, b: Rates) => preferredCurrency.indexOf(b.toCurrency) - preferredCurrency.indexOf(a.toCurrency));
  }

  fixedDecimals(num) {
    return Math.round(num * 100) / 100;
  }

  get currencyId() {
    return this.$store.state.user.currencyId
  }

  currencySymbol(id) {
    return currencyList[id] || '';
  }

  get currencyMap() {
    return (this.$store.state.currencyList || []).reduce((acc, item) => {
      acc[item.code] = item.name
      return acc
    }, {});
  }

  mounted() {
    this.loading = true
    this.currencyApi.getExchangeRates({ base_currency: this.currencyId })
      .then((rates: Rates[]) => this.rates = rates)
      .finally(() => {
        this.loading = false
        this.show = true
      })
  }

  close() {
    this.$emit('close');
  }
}
